import { WIDGET_VIEW_BOOLEAN } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const BooleanViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_BOOLEAN,
  component: () => import("./boolean-view-widget.component").then((m) => m.BooleanViewWidgetComponent)
};
